<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { QuestionCircleIcon } from '@thehotelsnetwork/icons/vue/linear';

import { track } from '@/utils/analytics';
import navigate from '@/utils/navigate';
import { getHcBenchdirect } from '@/config/hcLinks';

const { t } = useI18n();

const handleClick = () => {
  track('click - help center');
  navigate(getHcBenchdirect(), { newTab: true, external: true });
};
</script>

<template>
  <LpButton
    mode="transparent"
    size="small"
    color="gray"
    @click="handleClick"
  >
    <div class="flex flex-row items-center text-base font-normal">
      <QuestionCircleIcon class="flex-shrink-0 mr-2 w-5 h-5" />
      <p class="whitespace-nowrap max-xl:hidden">
        {{ t('Help Center') }}
      </p>
    </div>
  </LpButton>
</template>
